// Strict UK date formatting (DD/MM/YYYY).
function pad(n) { return String(n).padStart(2, "0"); }

export function formatDate(input) {
  if (!input) return "-";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d)) return "-";
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatDateTime(input) {
  if (!input) return "-";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d)) return "-";
  return `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// UK audit stamp: DD/MM/YYYY at HH:MM
export function formatStamp(input) {
  if (!input) return "-";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d)) return "-";
  return `${formatDate(d)} at ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// From a YYYY-MM-DD string (date-only, no timezone shift) -> DD/MM/YYYY
export function formatYmd(ymd) {
  if (!ymd || !/^\d{4}-\d{2}-\d{2}/.test(ymd)) return ymd || "-";
  const [y, m, d] = ymd.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

// Document expiry status from a YYYY-MM-DD string.
// Green (valid) > 30 days out · Amber (soon) <= 30 days · Red (expired) past.
// Returns { level: 'none'|'valid'|'soon'|'expired', label, days }.
export function docExpiryStatus(expiry) {
  if (!expiry || !/^\d{4}-\d{2}-\d{2}/.test(expiry)) return { level: "none", label: "No expiry set", days: null };
  const midnight = new Date(); midnight.setHours(0, 0, 0, 0);
  const d = new Date(expiry.slice(0, 10) + "T00:00:00");
  if (isNaN(d)) return { level: "none", label: "No expiry set", days: null };
  const days = Math.round((d - midnight) / 86400000);
  if (days < 0) return { level: "expired", label: `Expired ${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"} ago`, days };
  if (days <= 30) return { level: "soon", label: days === 0 ? "Expires today" : `Expires in ${days} day${days === 1 ? "" : "s"}`, days };
  return { level: "valid", label: `Valid · expires ${formatYmd(expiry)}`, days };
}
